export default __webpack_public_path__ + "static/Maíra da Rosa_MiniBio-d90a84df2423b4aaa683b35d4d5fe90b.webp";